import React from 'react';
import {OverlayTrigger, Popover} from "react-bootstrap";
import {faEllipsisH} from "@fortawesome/free-solid-svg-icons";
import IconButton from "./IconButton";

const MenuPopover = ({children, visible, onToggle, element = undefined, placement = 'right'}) => {
    const overlay = (
        <Popover id="popover-basic">
            <Popover.Body className='p-2'>
                {React.Children.map(children, (child) => {
                    return <div onClick={onToggle}>{child}</div>;
                })}
            </Popover.Body>
        </Popover>
    )

    return (
        <OverlayTrigger show={visible} trigger="click" placement={placement} rootClose overlay={overlay} >
            {element ? element : <IconButton icon={faEllipsisH} border='1px solid' borderColor='lightgray' onClick={onToggle}/>}
        </OverlayTrigger>
    );
};

export default MenuPopover;